import { ProductDirectory } from "./product";

export class CategoryDirectory {
    color: string;
    dealerGroupId: number;
    isMedia: number;
    name: string;
    ordinal: number;
    productCategoryId: number;
    products: any;
    constructor(data) {
        this.color = data.color;
        this.dealerGroupId = data.dealerGroupId;
        this.isMedia = data.isMedia;
        this.name = data.name;
        this.ordinal = data.ordinal;
        this.productCategoryId = data.productCategoryId;
        this.products = data.products.map(item => new ProductDirectory(item));
    }

}


// WEBPACK FOOTER //
// ./src/app/components/class/directory/category.ts